<template>
  <div class="relative bg-lightMenu">
    <div class="loginBG">
      <img src="../../assets/loginIcon.png" class="w-96 mb-56 mr-72" alt="">
    </div>
    <div class="w-screen min-h-loginbg px-3 z-10 flex items-center text-lightText relative">
      <notice-alerts class="top-14 lg:top-24 w-576"
                    v-show="alertShow"
                    :title="alertTitle"
                    :type="alertType"></notice-alerts>
      <div class="fixed top-0 left-0 w-screen h-topmenu bg-lightTop z-50">
        <div class="w-full h-full flex pl-6">
          <a class="flex items-center" href="https://www.cargosoon.com" target="_blank">
            <!-- <img src="../../assets/shipImg.svg"
                class="w-5 h-5 ml-4 mr-1"
                alt="" /> -->
            <!-- <img src="../../assets/newLogo.svg"
              class="w-10 h-10 mr-1 hidden sm:block"
              alt="" /> 
            <div class="text-20 font-bold text-white">Cargosoon</div> -->
            <img src="../../assets/cargosoonLogo1.png"
              class="h-8 mr-1"
              alt="" /> 
            <img src="../../assets/cargosoonLogo2.png"
              class="h-6"
              alt="" /> 
          </a>
        </div>
      </div>
      <div class="max-w-1440 w-full mx-auto my-28 flex justify-center">
        <div class="mr-20 hidden w-80 lg:flex flex-col justify-center">
          <div class="mb-3 text-3xl font-semibold">Free for L1 members</div>
          <div class="mb-3 text-5xl font-semibold" style="color: #ff6600;">$0</div>
          <div class="mb-2 flex items-center text-lg" style="color: #666;">
            <svg t="1693190651210" class="icon mr-2" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4827" width="16" height="16"><path d="M-31.315747 519.457481m54.305801-54.305801l45.435853-45.435854q54.305801-54.305801 108.611601 0l303.931466 303.931466q54.305801 54.305801 0 108.611601l-45.435854 45.435853q-54.305801 54.305801-108.611601 0l-303.931465-303.931465q-54.305801-54.305801 0-108.611601Z" p-id="4828" fill="#e66a10"></path><path d="M898.357541 105.745969m54.305801 54.305801l45.797892 45.797892q54.305801 54.305801 0 108.611602l-563.332174 563.332173q-54.305801 54.305801-108.611602 0l-45.797892-45.797892q-54.305801-54.305801 0-108.611601l563.332174-563.332174q54.305801-54.305801 108.611602 0Z" p-id="4829" fill="#ff6600"></path></svg>
            <div>10% off member price.</div>
          </div>
          <div class="mb-2 flex items-center" style="color: #666;">
            <svg t="1693190651210" class="icon mr-2" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4827" width="16" height="16"><path d="M-31.315747 519.457481m54.305801-54.305801l45.435853-45.435854q54.305801-54.305801 108.611601 0l303.931466 303.931466q54.305801 54.305801 0 108.611601l-45.435854 45.435853q-54.305801 54.305801-108.611601 0l-303.931465-303.931465q-54.305801-54.305801 0-108.611601Z" p-id="4828" fill="#e66a10"></path><path d="M898.357541 105.745969m54.305801 54.305801l45.797892 45.797892q54.305801 54.305801 0 108.611602l-563.332174 563.332173q-54.305801 54.305801-108.611602 0l-45.797892-45.797892q-54.305801-54.305801 0-108.611601l563.332174-563.332174q54.305801-54.305801 108.611602 0Z" p-id="4829" fill="#ff6600"></path></svg>
            <div>$80 Coupon for new customers.</div>
          </div>
          <div class="mb-2 flex items-center" style="color: #666;">
            <svg t="1693190651210" class="icon mr-2" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4827" width="16" height="16"><path d="M-31.315747 519.457481m54.305801-54.305801l45.435853-45.435854q54.305801-54.305801 108.611601 0l303.931466 303.931466q54.305801 54.305801 0 108.611601l-45.435854 45.435853q-54.305801 54.305801-108.611601 0l-303.931465-303.931465q-54.305801-54.305801 0-108.611601Z" p-id="4828" fill="#e66a10"></path><path d="M898.357541 105.745969m54.305801 54.305801l45.797892 45.797892q54.305801 54.305801 0 108.611602l-563.332174 563.332173q-54.305801 54.305801-108.611602 0l-45.797892-45.797892q-54.305801-54.305801 0-108.611601l563.332174-563.332174q54.305801-54.305801 108.611602 0Z" p-id="4829" fill="#ff6600"></path></svg>
            <div>30 days of free warehouse storage.</div>
          </div>
          <div class="mb-2 flex items-center" style="color: #666;">
            <svg t="1693190651210" class="icon mr-2" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4827" width="16" height="16"><path d="M-31.315747 519.457481m54.305801-54.305801l45.435853-45.435854q54.305801-54.305801 108.611601 0l303.931466 303.931466q54.305801 54.305801 0 108.611601l-45.435854 45.435853q-54.305801 54.305801-108.611601 0l-303.931465-303.931465q-54.305801-54.305801 0-108.611601Z" p-id="4828" fill="#e66a10"></path><path d="M898.357541 105.745969m54.305801 54.305801l45.797892 45.797892q54.305801 54.305801 0 108.611602l-563.332174 563.332173q-54.305801 54.305801-108.611602 0l-45.797892-45.797892q-54.305801-54.305801 0-108.611601l563.332174-563.332174q54.305801-54.305801 108.611602 0Z" p-id="4829" fill="#ff6600"></path></svg>
            <div>Unlimited shipping quotes</div>
          </div>
        </div>
        <div class="max-w-xl w-full bg-white flex rounded shadow-default">
          <div class="w-full sm:px-10 px-3.5 pt-8">
            <div class="title">
              <div class="text-lg font-bold">Log in</div>
            </div>

            <!-- <div class="flex">
              <div @click="istab = '0'" class="mr-6 py-2 border-b-2 cursor-pointer flex"
                :class="[istab == '0' ? 'border-orange font-semibold text-orange' : 'border-transparent hover:text-orange']">
                Email Login
              </div>
              <div @click="istab = '1'" class="py-2 border-b-2 cursor-pointer flex"
                :class="[istab == '1' ? 'border-orange font-semibold text-orange' : 'border-transparent hover:text-orange']">
                Account Login
              </div>
            </div> -->

            <div class="my-3.5">
              <div v-if="istab == '0' && ruleForm.login_way == 1" key="email" class="mb-3">
                <div class="pb-2 flex justify-between">
                  <label class="text-15 text-loginLabel">Email</label>
                  <!-- <div @click="selectLogin(2)" class="text-sm text-blue-400 underline cursor-pointer">Login with phone number</div> -->
                </div>
                <div class="relative">
                  <input v-model="ruleForm.email"
                        v-on:keyup.enter="userLogin()"
                        ref="email"
                        class="input"
                        v-validate="'required|email'"
                        name="email"
                        type="email"
                        placeholder="Enter your email" />
                  <div class="inputTips">{{ errors.first("email") }}</div>
                </div>
              </div>
              <div v-if="istab == '0' && ruleForm.login_way == 2" key="phone" class="mb-3">
                <div class="pb-2 flex justify-between">
                  <label class="text-15 text-loginLabel">Phone number</label>
                  <div @click="selectLogin(1)" class="text-sm text-blue-400 underline cursor-pointer">Login with email</div>
                </div>
                <div class="relative">
                  <input v-model="ruleForm.mobile"
                    v-on:keyup.enter="userLogin()"
                    class="input"
                    v-validate="'required|phone'"
                    name="phone"
                    type="text"
                    placeholder="Enter your phone number" />
                  <div class="inputTips">{{ errors.first("phone") }}</div>
                </div>
              </div>

              <div v-if="istab == '1'" class="mb-3">
                <div class="pb-2">
                  <label class="text-15 text-loginLabel">Account</label>
                </div>
                <div class="relative">
                  <input v-model="ruleForm.email"
                        v-on:keyup.enter="userLogin()"
                        ref="account"
                        class="input"
                        type="text"
                        placeholder="Enter your account" />
                </div>
              </div>

              <div v-if="ruleForm.check_way == 1" key="password" class="mb-6">
                <div class="pb-2">
                  <label class="text-15 text-loginLabel">Password</label>
                </div>
                <div>

                  <input v-model="ruleForm.password"
                        v-on:keyup.enter="userLogin()"
                        ref="password"
                        class="input"
                        name="password"
                        type="password"
                        v-validate="'required|password'"
                        placeholder="Must be 6 charactor or more" />
                  <div class="inputTips">{{ errors.first("password") }}</div>
                </div>
              </div>
              <div v-if="ruleForm.check_way == 2" key="code" class="mb-6">
                <div class="pb-2">
                  <label class="text-15 text-loginLabel">Verification code</label>
                </div>
                <div class="flex">
                  <div class="w-full">
                    <input v-model="ruleForm.verify_code"
                      v-on:keyup.enter="userLogin()"
                      class="input"
                      name="authCode"
                      type="text"
                      v-validate="'required|authCode'"
                      placeholder="Enter verification code" />
                    <div class="inputTips">{{ errors.first("authCode") }}</div>
                  </div>
                  <button v-show="showCode" @click="sendVerifyCode()"
                    class="ml-2.5 flex-shrink-0 rounded-md bg-orange hover:bg-orange1 text-white"
                    style="width: 86px;">
                    Send
                  </button>
                  <button v-show="!showCode"
                    class="ml-2.5 flex-shrink-0 rounded-md bg-gray-400 text-white cursor-default"
                    style="width: 86px;">
                    {{ codeNum }}
                  </button>
                </div>
              </div>

              <div class="flex justify-between text-sm mb-6">
                <!-- <label class="flex items-center cursor-pointer"
                      style="-webkit-user-select: none;
                -ms-user-select: none;
                user-select: none;">
                  <input class="mr-1.5 w-4 h-4"
                        type="checkbox" />
                  <div>Remember me</div>
                </label> -->
                <div v-if="ruleForm.check_way == 1" @click="selectPassword(2)" class="text-red-500 cursor-pointer hover:underline">verification code login</div>
                <div v-if="ruleForm.check_way == 2" @click="selectPassword(1)" class="text-red-500 cursor-pointer hover:underline">password login</div>
                <div v-if="ruleForm.check_way == 1">
                  <router-link class="tips" :to="{ name: 'forgotPassword' }">Forget the password?</router-link>
                </div>
              </div>
              <div>
                <button class="loginbtn"
                        @click.prevent="userLogin"
                        v-show="!showLoading">Log in</button>
                <button class="loading"
                        v-show="showLoading">
                  <svg class="animate-spin mx-auto my-0.5 h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24">
                    <circle class="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            stroke-width="4"></circle>
                    <path class="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                </button>
              </div>
            </div>

            <div class="pt-7 border-t border-gray-200">
              <div class="signUpGoogle border-orange text-orange" @click="signUpGoogle">
                <img src="../../assets/google.svg"
                    class="w-5 mr-4"
                    alt="" />
                <div>Log in with Google</div>
              </div>
              <div @click="loginWith('facebook')" class="signUpGoogle mt-3 border-blue-800 text-blue-800">
                <svg t="1701746780470" class="icon mr-3" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4470" width="20" height="20"><path data-v-087a94b2="" d="M967.4752 0H56.5248C25.2928 0 0 25.2928 0 56.5248v910.9504C0 998.7072 25.2928 1024 56.5248 1024h490.3936v-396.544H413.4912V472.9344h133.4272V358.912c0-132.3008 80.7936-204.288 198.8096-204.288 56.5248 0 105.0624 4.1984 119.2448 6.0928v138.24h-81.8176c-64.2048 0-76.5952 30.5152-76.5952 75.264v98.6624h153.0368l-19.968 154.5216h-133.12V1024h260.9664c31.232 0 56.5248-25.2928 56.5248-56.5248V56.5248C1024 25.2928 998.7072 0 967.4752 0z" fill="#1e40af" p-id="4471"></path></svg>
                <div>Log in with Fackbook</div>
              </div>
              <div @click="loginWith('tiktok')" class="signUpGoogle mt-3 border-black text-black">
                <svg t="1723513266463" class="icon mr-3" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6481" width="20" height="20"><path d="M0 0h1024v1024H0z" fill="#FFFFFF" p-id="6482"></path><path d="M910.912 0H113.088C50.88 0 0 50.88 0 113.088v797.824C0 973.12 50.88 1024 113.088 1024h797.824c62.208 0 113.088-50.88 113.088-113.088V113.088C1024 50.88 973.12 0 910.912 0z" fill="#000000" p-id="6483"></path><path d="M444.608 416.256V384.64a200.512 200.512 0 0 0-32.512-2.56 241.536 241.536 0 0 0-241.408 241.152c0 82.112 41.088 153.92 103.552 197.568a239.616 239.616 0 0 1-65.024-164.224C208.32 525.76 313.6 418.816 444.608 416.256z" fill="#00F2EA" p-id="6484"></path><path d="M450.56 767.744c59.136 0 107.904-47.04 110.464-106.048V135.744h95.872c-1.664-11.136-3.392-22.208-3.392-33.344H522.496v525.952a110.4 110.4 0 0 1-110.4 106.048c-18.88 0-35.968-4.224-51.392-12.8 20.544 28.16 53.12 46.144 89.92 46.144z" fill="#00F2EA" p-id="6485"></path><path d="M736.512 255.488a179.84 179.84 0 0 1-44.48-119.68h-35.136a183.296 183.296 0 0 0 79.616 119.68zM412.096 513.792c-60.8 0-110.464 49.6-110.464 110.272 0 42.816 24 79.552 59.072 97.536a110.336 110.336 0 0 1 122.432-169.344V417.92a200.576 200.576 0 0 0-32.512-2.56h-6.016v102.592a135.616 135.616 0 0 0-32.512-4.224v0.064z" fill="#FF004F" p-id="6486"></path><path d="M836.672 314.496v101.76a305.664 305.664 0 0 1-182.336-59.008v266.88a241.472 241.472 0 0 1-380.096 197.504 243.008 243.008 0 0 0 177.216 76.992 241.536 241.536 0 0 0 241.408-241.152v-266.88a313.6 313.6 0 0 0 182.4 59.008V317.888a185.6 185.6 0 0 1-38.592-3.392z" fill="#FF004F" p-id="6487"></path><path d="M653.44 624.128v-266.88c53.12 38.208 116.928 58.88 182.4 59.008v-101.76a185.152 185.152 0 0 1-99.328-59.008 182.4 182.4 0 0 1-80.448-119.68H561.024v525.952a110.4 110.4 0 0 1-160.96 93.76 110.72 110.72 0 0 1-39.36-33.92 111.04 111.04 0 0 1-59.072-97.472c0-60.8 49.664-110.336 110.464-110.336 11.136 0 22.208 1.664 32.512 5.12V416.256a241.088 241.088 0 0 0-236.288 241.216 239.36 239.36 0 0 0 65.088 164.16 242.624 242.624 0 0 0 231.04 25.408 241.088 241.088 0 0 0 149.056-222.912h-0.064z" fill="#FFFFFF" p-id="6488"></path></svg>
                <div>Log in with Tiktok</div>
              </div>
            </div>
            <div class="p-5 border-t border-gray-200 flex justify-center text-sm">
              <span>Don't Have An Account?</span>&nbsp;
              <router-link class="tips"
                          :to="{ name: 'signUp' }"
                          replace>Sign up</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-screen min-h-50 bg-lightTop z-20 text-xs text-gray-300 flex justify-center items-center relative">
      <div class="text-center p-4">
        By clicking the Accept and Continue button, you acknowledge that you have read and reviewed the <a class="px-1 underline cursor-pointer" href="https://www.cargosoon.com/terms" target="_blank">Cargosoon Terms and Conditions</a> and the <a class="px-1 underline cursor-pointer" href="https://www.cargosoon.com/privacy" target="_blank">Cargosoon Privacy Policy</a> and agree to be subject to those terms and policies.
      </div>
    </div>
  </div>
</template>
<script>
import NoticeAlerts from '@/components/NoticeAlerts'
import uaParser from 'ua-parser-js'
import {
  getThirdLink,
  sendVerify
} from '@/api/user'
export default {
  name: 'Login',
  components: {
    NoticeAlerts,
  },
  data() {
    return {
      alertShow: false,
      alertTitle: '',
      alertType: '',
      showLoading: false,
      ruleForm: {
        email: '',
        password: '',
        browser: '',
        sys: '',
        agent: '',
        machine: '',
        language: '',
        login_way: 1,
        check_way: 1,
        mobile: '',
        verify_code: '',
      },
      istab: '0',
      invitation_code: '',
      forms: {},
      showCode: true,
      codeNum: 60,
      source: 1,
    }
  },
  created(){
    if(window.location.host == "app.cargosoon.com"){
      this.source = 1
    }else{
      this.source = 2
    }
  },
  methods: {
    async userLogin() {
      const success = await this.$validator.validateAll()
      if (success) {
        this.alertShow = false
        this.showLoading = true
        try {
          await this.$store.dispatch('userLogin', this.ruleForm)
          setTimeout(() => {
            // if(this.$store.state.user.userInfo.email == null){
            //   this.$router.push({
            //     name:'profile',
            //     params: {
            //       status: 'account',
            //     },
            //   })
            // }else{
            //   if(localStorage.getItem("loginto") == '2'){
            //     if(this.$store.state.user.userInfo.super_level == 'L1'){
            //       this.$router.push({
            //         name:'FCL',
            //         params: {level:'L1'},
            //       })
            //     }else{
            //       this.$router.push('/main/FCL')
            //     }
            //   }else{
            //     if(this.$store.state.user.userInfo.super_level == 'L1'){
            //       this.$router.push({
            //         name:'shippingList',
            //         params: {level:'L1'},
            //       })
            //     }else{
            //       this.$router.push('/main/booking')
            //       // this.$router.push('/main/dashboard')
            //     }
            //   }
            // }
            if(this.$store.state.user.userInfo.delivery_status == 0){
              this.$router.push({
                name:'shippingList',
              })
            }else{
              this.$router.push('/main/dashboard')
            }
            this.showLoading = false
          }, 800)
          // console.log('用户信息', this.$store.state.user.userInfo)
          localStorage.setItem(
            'userInfo',
            JSON.stringify(this.$store.state.user.userInfo)
          )
          localStorage.setItem(
            'userId',
            JSON.stringify(this.$store.state.user.userInfo.id)
          )
          localStorage.setItem(
            'userImg',
            JSON.stringify(this.$store.state.user.userInfo.img)
          )
          localStorage.setItem(
            'first_name',
            JSON.stringify(this.$store.state.user.userInfo.first_name)
          )
          localStorage.setItem(
            'last_name',
            JSON.stringify(this.$store.state.user.userInfo.last_name)
          )
          localStorage.setItem(
            'customer_manage',
            JSON.stringify(this.$store.state.user.userInfo.manage)
          )
          
        } catch (error) {
          this.showLoading = false
          this.alertShow = true
          this.alertTitle = error.message
        }
      } else {
      }
    },
    signUpGoogle(){
      // window.location.href = 'https://app.cargosoon.com/api/google/googleLogin'
      window.location.href = window.location.protocol + "//" + window.location.host + "/api/google/googleLogin"
    },
    loginWith(type){
      getThirdLink({
        type,
        source: this.source,
        source_client: 1
      }).then((res)=>{
        window.location.href = res.data.url
      })
    },
    async toThirdLogin(){
      await this.$store.dispatch('thirdLogins', this.forms)
      setTimeout(() => {
        if(this.$store.state.user.userInfo.delivery_status == 0){
          this.$router.push({
            name:'shippingList',
          })
        }else{
          // this.$router.push('/main/dashboard')
          window.location.href = '/new/'
        }
      },800)
      localStorage.setItem(
        'userInfo',
        JSON.stringify(this.$store.state.user.userInfo)
      )
      localStorage.setItem(
        'userId',
        JSON.stringify(this.$store.state.user.userInfo.id)
      )
      localStorage.setItem(
        'userImg',
        JSON.stringify(this.$store.state.user.userInfo.img)
      )
      localStorage.setItem(
        'first_name',
        JSON.stringify(this.$store.state.user.userInfo.first_name)
      )
      localStorage.setItem(
        'last_name',
        JSON.stringify(this.$store.state.user.userInfo.last_name)
      )
      localStorage.setItem(
        'customer_manage',
        JSON.stringify(this.$store.state.user.userInfo.manage)
      )
    },
    selectLogin(type){
      this.ruleForm.login_way = type
      if(type == 1){
        this.ruleForm.mobile = ''
      }else{
        this.ruleForm.email = ''
      }
      setTimeout(()=>{
        this.resetValidate()
      },1)
    },
    selectPassword(type){
      this.ruleForm.check_way = type
      if(type == 1){
        this.ruleForm.verify_code = ''
      }else{
        this.ruleForm.password = ''
      }
      setTimeout(()=>{
        this.resetValidate()
      },1)
    },
    resetValidate(){
      this.$validator.reset()
    },
    sendVerifyCode(){
      let timer = setInterval(() => {
        this.codeNum -= 1
        if (this.codeNum <= 0) {
          clearInterval(timer)
          this.showCode = true
          this.codeNum = 60
        }
      }, 1000)
      this.showCode = false
      // if(){
        sendVerify({
          source: this.source,
          scene: 2,
          send_way: this.ruleForm.login_way,
          email: this.ruleForm.email,
          mobile: this.ruleForm.mobile,
        }).then((res)=>{
          if(res.code == -1){
            this.$message({
              message: res.msg,
              offset: 70
            })
            clearInterval(timer)
            this.showCode = true
            this.codeNum = 60
          }
        })
      // }
    },
  },
  mounted() {
    this.$refs.email.focus()
    const ua = uaParser(navigator.userAgent)
    this.ruleForm.browser = ua.browser.name
    this.ruleForm.sys = ua.os.name + ua.os.version
    this.ruleForm.agent = ua.ua
    this.ruleForm.machine = window.screen.width + '*' + window.screen.height
    this.ruleForm.language = window.navigator.language
    if(localStorage.getItem('invitation_code') === 'undefined'){
      this.invitation_code = ''
    }else{
      this.invitation_code = localStorage.getItem('invitation_code')
    }
    if(this.$route.query.code){
      this.forms = {
        state: this.$route.query.state,
        code: this.$route.query.code,
        source: this.source,
        invitation_code: this.invitation_code,
        sys: this.ruleForm.sys,
        browser: this.ruleForm.browser,
        agent: this.ruleForm.agent,
        machine: this.ruleForm.machine,
        language: this.ruleForm.language,
        source_client: 1,
      }
      this.toThirdLogin()
    }
  },
  watch: {},
}
</script>

<style lang="postcss" scoped>
.title {
  @apply w-full pb-3 text-center;
}

.loginbtn {
  @apply w-full px-2.5 py-3.5 mb-3.5 text-white bg-orange hover:bg-orange1 rounded-md font-semibold border-0 cursor-pointer;
}

.tips {
  @apply text-orange hover:underline;
}

.signUpGoogle {
  @apply w-full px-6 py-3 rounded-md text-sm cursor-pointer flex justify-center items-center border hover:bg-inputGoogle;
}

.inputTips {
  @apply text-xs text-red-500 absolute;
}

.loading {
  @apply w-full px-2.5 py-3.5 mb-3.5 bg-orange justify-center rounded-md;
}

.loginBG {
  @apply fixed top-0 left-0 w-full h-full hidden sm:flex z-10 justify-center items-end;
  background: url("../../assets/loginBG1.webp") 50% 100% / cover no-repeat fixed;
}
</style>
